import { Box } from '@factorialco/deprecated-design-system'
import { F0Icon } from '@factorialco/f0-react'
import { Bell, Check, Sparkles } from '@factorialco/f0-react/icons/app'

type Props = {
  isModuleAcquired: boolean
  isAlreadyReleased: boolean
  isAlreadySubscribed: boolean
}

const ModuleStateIcon = ({ isModuleAcquired, isAlreadyReleased, isAlreadySubscribed }: Props) => {
  if (!isAlreadyReleased) {
    return (
      <Box
        background="grey300"
        padding="s4"
        borderRadius={{
          all: 'abs012',
        }}
        border={{
          all: {
            width: 's1',
            style: 'solid',
            color: 'grey300',
          },
        }}
      >
        <F0Icon
          color="grey800"
          icon={isAlreadySubscribed ? Check : Bell}
          size="md"
          fontWeight="bold"
        />
      </Box>
    )
  }
  if (!isModuleAcquired) {
    return (
      <Box
        style={{
          backgroundColor: 'rgb(245, 165, 28, 0.1)',
          borderColor: 'rgb(16, 184, 129, 0.01',
        }}
        padding="s4"
        borderRadius={{
          all: 'abs012',
        }}
        border={{
          all: {
            width: 's1',
            style: 'solid',
            color: 'teal1000',
          },
        }}
      >
        <F0Icon
          color="rgb(245, 165, 28, 1)"
          icon={isModuleAcquired ? Check : Sparkles}
          size="md"
          fontWeight="bold"
        />
      </Box>
    )
  }

  return (
    <Box
      style={{
        backgroundColor: 'rgb(16, 184, 129, 0.1',
        borderColor: 'rgb(16, 184, 129, 0.01',
      }}
      padding="s8"
      borderRadius={{
        all: 'abs012',
      }}
      border={{
        all: {
          width: 's1',
          style: 'solid',
          color: 'teal1000',
        },
      }}
    >
      <Box
        style={{ backgroundColor: '#10B881', borderColor: '#10B881' }}
        borderRadius={{
          all: 'abs016',
        }}
        border={{
          all: {
            width: 's1',
            style: 'solid',
            color: 'teal1000',
          },
        }}
      >
        <F0Icon
          icon={isModuleAcquired ? Check : Sparkles}
          color="white"
          size="xs"
          fontWeight="bold"
        />
      </Box>
    </Box>
  )
}

export default ModuleStateIcon
